import { render, staticRenderFns } from "./InvoicePaymentsPopover.vue?vue&type=template&id=cd4c4e32&scoped=true"
import script from "./InvoicePaymentsPopover.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentsPopover.vue?vue&type=script&lang=js"
import style0 from "./InvoicePaymentsPopover.vue?vue&type=style&index=0&id=cd4c4e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4c4e32",
  null
  
)

export default component.exports